import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Stack } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import CompleteTaskDialog from "./CompleteTaskDialog";

interface Props {
  readonly isCompleted: boolean;
  readonly iconsDirection: "row" | "column";
  readonly canDelete: boolean;
  readonly onComplete: (note?: string) => Promise<void>;
  readonly onDelete: () => void;
  readonly onEdit: () => void;
}

const TaskActions: FC<Props> = ({ isCompleted, iconsDirection, canDelete, onComplete, onDelete, onEdit }) => {
  const [completeOpen, setCompleteOpen] = useState(false);
  return (
    <>
      <Stack
        direction={iconsDirection}
        sx={{ alignItems: "center" }}
        spacing={iconsDirection === "row" ? 1 : undefined}
      >
        <IconButton edge="end" size="small" aria-label="Edytuj zadanie" onClick={onEdit} disabled={isCompleted}>
          <EditIcon />
        </IconButton>
        <IconButton
          edge="end"
          size="small"
          aria-label="Oznacz jako wykonane"
          onClick={() => setCompleteOpen(true)}
          disabled={isCompleted}
        >
          {isCompleted ? <CheckCircleIcon color="success" /> : <CheckCircleOutlineIcon />}
        </IconButton>
        {canDelete && (
          <IconButton edge="end" size="small" aria-label="Usuń zadanie" onClick={onDelete}>
            <DeleteIcon />
          </IconButton>
        )}
      </Stack>
      <CompleteTaskDialog
        open={completeOpen}
        onCancel={() => setCompleteOpen(false)}
        onConfirm={async (note) => {
          await onComplete(note);
        }}
      />
    </>
  );
};

export default TaskActions;
